<div class="flex flex-col justify-center items-center">
  <div class="max-w-md w-full">
    <mat-toolbar class="toolbar mat-elevation-z2">{{
      projectName
    }}</mat-toolbar>

    <div class="px-4 py-8">
      <section class="text-center pb-8 w-full">
        <header class="flex justify-center items-center flex-col">
          <h1 class="text-heading-lg text-balance" [ngClass]="{ 'text-xl': name.includes('##') || name.includes('$$') }">{{ nameToDisplay }}</h1>
          <span class="text-heading-sm">{{ notation }}</span>
          <h3
            class="max-w-md text-xl text-pretty"
            [innerHTML]="rationales"
          ></h3>
        </header>
        <hr class="my-4" />
      </section>

      <ng-container
        *ngFor="
          let voteType of ['positive', 'neutral', 'negative'];
          let i = index
        "
      >
        <section class="text-center py-8">
          <button
            *ngIf="!this[voteType + 'Vote'] && !readOnlyName && name !== '....'"
            (click)="setVote(voteType)"
            type="button"
            [ngClass]="{
              'border-positive text-positive': voteType === 'positive',
              'border-neutral text-neutral': voteType === 'neutral',
              'border-negative text-negative': voteType === 'negative'
            }"
            class="px-4 py-2 text-xl rounded border hover:bg-[#ffffff1a] mat-elevation-z2 w-64"
          >
            {{ voteType | uppercase }}
          </button>
          <button
            *ngIf="this[voteType + 'Vote'] && !readOnlyName && name !== '....'"
            (click)="removeVote()"
            type="button"
            [ngClass]="{
              'border-positiveAccent bg-positiveAccent':
                voteType === 'positive',
              'border-neutralAccent bg-neutralAccent': voteType === 'neutral',
              'border-negativeAccent bg-negativeAccent': voteType === 'negative'
            }"
            class="px-4 py-2 text-xl rounded border mat-elevation-z2 w-64 text-white"
          >
            {{ voteType | uppercase }}
          </button>
          <button
            *ngIf="readOnlyName || name === '....'"
            [disabled]="true"
            type="button"
            class="px-4 py-2 text-xl rounded border text-gray-400 mat-elevation-z2 w-64"
          >
            {{ voteType | uppercase }}
          </button>
        </section>
      </ng-container>

      <div class="my-8 w-full" *ngIf="projectName?.toUpperCase() !== 'ASTRYX'">
        <app-new-name> </app-new-name>
      </div>

      <div class="flex flex-col gap-6 justify-center pb-8">
        <h3 class="text-pretty text-center text-xl">Presentation Progress</h3>
        <div
          class="flex h-4 overflow-hidden text-xs bg-[#e9ecef] w-full rounded mat-elevation-z2"
        >
          <div
            class="flex justify-center overflow-hidden text-white text-center whitespace-nowrap bg-[#17a2b8]"
            [ngStyle]="progressBarCompletion"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ progressBarValue }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
